import BillingInfoModal from './BillingInfoModal';

export default BillingInfoModal;
